import { Zoom } from "react-awesome-reveal";
import { Slide } from "react-awesome-reveal";
import useBreakpoint from "../../hooks/useBreakpoints";
import Gradient from "../Gradient";
import Music from "../../assets/images/music.png";

const ServiceSection = ({ data, anchorId }) => {
  const { isLaptop } = useBreakpoint();

  if (!data) return null;

  return (
    <section className="section services-section flex-wrapper" id={anchorId}>
      <div className="flex-container section-container">
        <div className="left-block">
          <Slide direction="left" triggerOnce>
            <span className="subTitle">{data.subTitle}</span>
            <h2 className="services-title">{data.title}</h2>
            <div className="description">{data.description}</div>
          </Slide>
        </div>

        <div className="services-grid">
          {data.items?.map((item) => (
            <div key={item.id} className="service-item">
              <img
                src={item?.icon?.url}
                alt={item.title}
                className="service-icon"
              />
              <h3 className="service-title">{item.title}</h3>
              <div
                className="service-description"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          ))}
        </div>
      </div>
      <Zoom duration={3000} cascade triggerOnce>
        <img className="music-spin" src={Music} alt="music" />
      </Zoom>

      <Gradient
        imageName="gradient4"
        right="initial"
        className="gradientLeft"
        bottom={isLaptop ? "-100px" : "initial"}
        left="0"
        top={isLaptop ? "initial" : "20%"}
        width={isLaptop ? "1000px" : "400px"}
        height={isLaptop ? "1000px" : "600px"}
      />
    </section>
  );
};

export default ServiceSection;
